"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WordCloud = void 0;
const utils_1 = require("../../../utils");
const lodash_1 = require("lodash");
var WordCloud;
(function (WordCloud) {
    WordCloud.type = 'wordCloud';
    let Answer;
    (function (Answer) {
        Answer.maxWordLength = 150;
        Answer.maxWordCount = 200;
        function numberOfWords(answer) {
            return (0, lodash_1.size)(answer && answer.words);
        }
        Answer.numberOfWords = numberOfWords;
        function words(answer) {
            return (0, lodash_1.map)(answer && answer.words, (raw) => ({
                source: raw,
                normalized: normalizeWordForComparison(raw),
            }));
        }
        Answer.words = words;
        function normalizedWords(answer) {
            return (0, lodash_1.map)(answer && answer.words, (word) => normalizeWordForComparison(word));
        }
        Answer.normalizedWords = normalizedWords;
        function sourceWords(answer) {
            return (answer && answer.words) || [];
        }
        Answer.sourceWords = sourceWords;
        function containsWord(answer, word, caseInSensitive) {
            const words = Answer.normalizedWords(answer);
            return words.includes(normalizeWordForComparison(word));
        }
        Answer.containsWord = containsWord;
        function normalizeWordForComparison(word) {
            return (0, utils_1.parseStringWithOptions)(word, { asLowercase: true, normalizeDiacritics: true });
        }
        Answer.normalizeWordForComparison = normalizeWordForComparison;
        function isDone(answer) {
            return numberOfWords(answer) > 0;
        }
        Answer.isDone = isDone;
    })(Answer = WordCloud.Answer || (WordCloud.Answer = {}));
})(WordCloud || (exports.WordCloud = WordCloud = {}));
//# sourceMappingURL=WordCloud.js.map